// @ts-check
// Importação de planilhas, parte isomórfica: leitura de CSV e XLSX, destinos por objeto, sugestão de mapeamento,
// conversão de células e chaves de duplicidade. A SPA usa tudo; o motor usa as chaves de duplicidade.
export * from './parse-csv.js';
export * from './read-xlsx.js';
export * from './text-matching.js';
export * from './import-targets.js';
export * from './convert-cell.js';
export * from './build-rows.js';
export * from './auto-match.js';
export * from './family-template.js';

// limites da importação (doc 14, seção 9.1), compartilhados entre a SPA e a API
export const MAXIMUM_IMPORT_ROWS = 10_000;
export const IMPORT_BATCH_SIZE = 200;
export const DUPLICATE_STRATEGIES = Object.freeze(['SKIP', 'UPDATE', 'CREATE']);
